module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-template/user-template.component.scss
// module id = ./src/app/user-template/user-template.component.scss
// module chunks = main